import styled from "styled-components";

export const ContainerDetail = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 8vh;
`;

export const DetailImg = styled.img`
  height: 30vh;
  margin-bottom: 20px;
`;

export const Details = styled.p`
  margin: auto;
  padding: 4px 0;
  align-self: start;
`;
